import { SelectProps } from 'antd/lib/select';
import { Select } from 'antd';
import { useMemo } from 'react';
import { FrequencyEnum, Option } from '../../../types';

function SelectFrequency({
  value,
  ...props
}: SelectProps<FrequencyEnum, Option>) {
  const options = useMemo(
    () => Object.entries(FrequencyEnum).map(([key, text]) => ({
      label: text,
      value: key,
    })),
    [],
  );

  return (
    <Select
      {...props}
      options={options}
      allowClear
      placeholder="Please select"
      value={value || undefined}
    />
  );
}

export default SelectFrequency;
